import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import { useState } from 'react'
import MenuDrawer from './components/Menu/MenuDrawer'
function Sidebar() {
  useInterfaceLanguage();
  const [open, setOpen] = useState(false)

  return (
    <div>
      <MenuDrawer open={open} setOpen={setOpen} />
    </div>
  )
}

export default Sidebar
